module.exports = __webpack_public_path__ + "img/gantt.48d5e5fb.svg";